/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QueueSummary
 */
export interface QueueSummary {
    /**
     * 
     * @type {number}
     * @memberof QueueSummary
     */
    queueDepth?: number;
    /**
     * 
     * @type {number}
     * @memberof QueueSummary
     */
    overdueCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueueSummary
     */
    dueTodayCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueueSummary
     */
    dueThisWeekCount?: number;
}

/**
 * Check if a given object implements the QueueSummary interface.
 */
export function instanceOfQueueSummary(value: object): value is QueueSummary {
    return true;
}

export function QueueSummaryFromJSON(json: any): QueueSummary {
    return QueueSummaryFromJSONTyped(json, false);
}

export function QueueSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueueSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'queueDepth': json['queueDepth'] == null ? undefined : json['queueDepth'],
        'overdueCount': json['overdueCount'] == null ? undefined : json['overdueCount'],
        'dueTodayCount': json['dueTodayCount'] == null ? undefined : json['dueTodayCount'],
        'dueThisWeekCount': json['dueThisWeekCount'] == null ? undefined : json['dueThisWeekCount'],
    };
}

export function QueueSummaryToJSON(json: any): QueueSummary {
    return QueueSummaryToJSONTyped(json, false);
}

export function QueueSummaryToJSONTyped(value?: QueueSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'queueDepth': value['queueDepth'],
        'overdueCount': value['overdueCount'],
        'dueTodayCount': value['dueTodayCount'],
        'dueThisWeekCount': value['dueThisWeekCount'],
    };
}

